export default "__VITE_ASSET__D24vCO0x__"